import './EventsOverview.scss';
import template from './EventsOverview.vhtml';
import $ from 'jquery';
import EventBus from '../eventBus';

export default {
	name: 'EventsOverview',
	template: template,
	props: {},
	data: () => ({
		events: '',
		activeType: '',
		loading: true,
	}),
	computed: {},
	methods: {
		getItems() {
			this.loading = true;
			const query = window.location.search;
			$.get('/wp-json/gi/v1/events' + query)
				.then(result => {
					this.events = result;
				})
				.catch(e => {
					console.log(e);
				})
				.always(() => {
					// Fake loadtime to avoid content flickering
					setTimeout(() => {
						this.loading = false;
					}, 500);
				});
		},
		revealDelay(index) {
			const oneToIndex = index + 1;
			const delay = oneToIndex.toString() + '50';

			return delay;
		},
		noYear(date) {
			const splitted = date.split('/');
			const noYear = splitted.slice(0, -1);
			return noYear.join('/');
		},
		yearClass(date) {
			const splitted = date.split('/');
			const last = splitted.pop();
			const noYear = date.replace('/' + last, '');
			return noYear + '<span class="fade-year">/' + last + '</span>';
		},
		showDateOnCard(event) {
			return 'start_date' in event && event.start_date !== '' && event.start_date !== null;
		}
	},
	mounted() {
		this.getItems();
		EventBus.$on('type-changed', slug => {
			this.activeType = slug;
			this.events = '';
			this.getItems();
		});
	},
};
